import React from 'react';

import {BufferConditionKeys, MeltingTempPreferences, NucleotideType} from 'biojs/BioConstants';

import MeltingTempOption from './MeltingTempOption';

interface SharedMeltingTempParamsProps {
  optionsHaveValidationError: {[key in BufferConditionKeys]: boolean};
  meltingTempOptions: MeltingTempPreferences;
  nucleotideType: NucleotideType;
  setMeltingTempOptions: (prefs: MeltingTempPreferences) => void;
  setOptionsHaveValidationError: (errors: {[key in BufferConditionKeys]: boolean}) => void;
}

export default function SharedMeltingTempParams(props: SharedMeltingTempParamsProps): JSX.Element {
  return (
    <div className="row">
      <MeltingTempOption optionKey="dnaConc" {...props} />
      <MeltingTempOption optionKey="monovalentConc" {...props} />
    </div>
  );
}
